export class ErrorHelper {
  /** Error that occurs when a dynamic import fails to fetch a JS chunk. E.g. due to HTTP 404 error. */
  public static isDynamicImportFetchError(err: Error): boolean {
    const typeErr = err as TypeError;

    // check URL presence like:
    // https://app-development.nexusfleet.io/assets/DamageDetectionsPage-C92PJQlr.js
    const jsChunkRegex = new RegExp(`${window.location.origin}/[^/]+/[^/]+\\.js`);

    return (
      !!err &&
      err.name === TypeError.name &&
      // unfortunately, the only way to detect this error is by checking the message text
      (typeErr.message.includes("Failed to fetch dynamically imported module:") ||
        typeErr.message.includes("TypeError: Failed to fetch dynamically imported module:") ||
        jsChunkRegex.test(typeErr.message))
    );
  }
}
